"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = exports.defaultProps = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var noop_1 = tslib_1.__importDefault(require("lodash/fp/noop"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Dialog_1 = tslib_1.__importDefault(require("@material-ui/core/Dialog"));
var Grid_1 = tslib_1.__importDefault(require("@material-ui/core/Grid"));
var Buttons_1 = require("../Buttons");
exports.defaultProps = {
    open: false,
    onClose: noop_1.default,
    closeBtnText: '',
    onConfirm: noop_1.default,
    onSecondary: noop_1.default,
    confirmBtnText: '',
    noCloseIcon: true,
    isDisabled: false,
};
exports.Modal = function (props) {
    var children = props.children, closeBtnText = props.closeBtnText, confirmBtnText = props.confirmBtnText, title = props.title, open = props.open, noCloseIcon = props.noCloseIcon, onClose = props.onClose, onConfirm = props.onConfirm, onSecondary = props.onSecondary, isDisabled = props.isDisabled, rest = tslib_1.__rest(props, ["children", "closeBtnText", "confirmBtnText", "title", "open", "noCloseIcon", "onClose", "onConfirm", "onSecondary", "isDisabled"]);
    var showCancelButton = onClose && closeBtnText;
    var onCancel = function (event) {
        if (onSecondary) {
            onSecondary(event);
        }
        if (onClose) {
            onClose(event);
        }
    };
    var showConfirmButton = onConfirm && confirmBtnText;
    return (React.createElement(Dialog_1.default, tslib_1.__assign({ open: open, onBackdropClick: onClose, onEscapeKeyDown: onClose, PaperProps: {
            square: true,
        } }, rest),
        React.createElement(Container, null,
            React.createElement(Header, { className: "modal-header" },
                React.createElement("div", null, title),
                !noCloseIcon && React.createElement(Buttons_1.IconButton, { onClick: onClose, icon: "close" })),
            children,
            (showCancelButton || showConfirmButton) && (React.createElement(ButtonBar, null,
                React.createElement(Grid_1.default, { container: true, spacing: 1 },
                    showCancelButton && (React.createElement(Grid_1.default, { item: true },
                        React.createElement(Buttons_1.Button, { buttonStyle: "SECONDARY", onClick: onCancel }, closeBtnText))),
                    showConfirmButton && (React.createElement(Grid_1.default, { item: true },
                        React.createElement(Buttons_1.Button, { borderless: true, disabled: isDisabled, onClick: onConfirm }, confirmBtnText)))))))));
};
var Header = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  && {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: ", ";\n    font-family: ", ";\n    font-size: 1.8rem;\n    line-height: 3.2rem;\n    padding-bottom: 2.4rem;\n  }\n  && i {\n    font-size: 2.4rem;\n  }\n"], ["\n  && {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: ", ";\n    font-family: ", ";\n    font-size: 1.8rem;\n    line-height: 3.2rem;\n    padding-bottom: 2.4rem;\n  }\n  && i {\n    font-size: 2.4rem;\n  }\n"])), function (props) { return props.theme.colors.NTDarkGrey[700]; }, function (props) { return props.theme.fonts.robotoMedium; });
var ButtonBar = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  padding-top: 3.2rem;\n"], ["\n  padding-top: 3.2rem;\n"])));
var Container = styled_components_1.default.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  & {\n    padding: 2.5rem 3.2rem 3.2rem 3.2rem;\n  }\n"], ["\n  & {\n    padding: 2.5rem 3.2rem 3.2rem 3.2rem;\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3;
